import React from "react";
import ProductItem from "./ProductItem";

interface DropDown {
  image: string;
  name: string;
  quantity: number;
  productId: number;
}

interface ProductArrangementProps {
  selectedProducts: DropDown[];
  onClearProducts: () => void;
  moveProduct: (dragIndex: number, hoverIndex: number) => void;
  removeProduct: (product: DropDown, e: React.MouseEvent) => void;
}

const ProductArrangement: React.FC<ProductArrangementProps> = ({
  selectedProducts,
  onClearProducts,
  moveProduct,
  removeProduct,
}) => {
  return (
    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center">
          <div className="flex-shrink-0 w-8 h-8 bg-customGreenColor text-white rounded-full flex items-center justify-center font-bold">
            2
          </div>
          <div className="ml-4">
            <h2 className="text-xl font-semibold text-gray-800">
              Arrange Products
            </h2>
            <p className="text-gray-600 mt-1">
              Drag and drop products to set their display order during the live
              stream
            </p>
          </div>
        </div>
      </div>

      <div className="bg-gray-50 border-2 border-dashed border-gray-200 rounded-lg p-6">
        <div className="flex flex-wrap gap-4">
          {selectedProducts.map((product, index) => (
            <ProductItem
              key={product.productId}
              product={product}
              index={index}
              moveProduct={moveProduct}
              removeProduct={removeProduct}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductArrangement;
